import { BottomCenteredDrawer } from "@jugl-web/ui-components/web/BottomCenteredDrawer";
import React from "react";
import { SelectSubscriptionFormProvider } from "@web-src/modules/workspace/components/SelectSubscriptionForm/SelectSubscriptionFormProvider";
import { SummaryStep } from "./components/SummaryStep";
import { ReactComponent as RocketIcon } from "./assets/rocket.svg";
import { SelectedPlanInfo } from "./components/SummaryStep/types";

type Props = {
  isOpen: boolean;
  planInfo?: SelectedPlanInfo;
  onClose: () => void;
};

export const CompletePurchaseDialogContent: React.FC<Props> = ({
  isOpen,
  planInfo,
  onClose,
}) => {
  if (!planInfo) return null;
  return (
    <BottomCenteredDrawer
      isOpen={isOpen}
      onClose={onClose}
      size="fullscreen"
      header={{
        type: "title",
        title: (
          <div className="flex items-center gap-3">
            <RocketIcon />
            Plans
          </div>
        ),
      }}
    >
      <SummaryStep planInfo={planInfo} />
    </BottomCenteredDrawer>
  );
};

export const CompletePurchaseDialog = ({
  isOpen,
  planInfo,
  onClose,
}: Props) => {
  return (
    <SelectSubscriptionFormProvider>
      <CompletePurchaseDialogContent
        isOpen={isOpen}
        onClose={onClose}
        planInfo={planInfo}
      />
    </SelectSubscriptionFormProvider>
  );
};
